<script setup lang="ts">
import type { CarDetailsImage } from '@autobid/ui/types/components/CarDetails'
import { useCarGallery } from '@autobid/ui/composables/car/useCarGallery'
import { replaceImageSize } from '@autobid/ui/utils/car/generateImageSizes'
import { getDetailsImageAlt } from '@autobid/ui/utils/car/getDetailsImageAlt'

interface Props {
  images?: CarDetailsImage[]
}

defineProps<Props>()

const { locale } = useI18n()
const { injectShowGallery } = useCarGallery()
const showGallery = injectShowGallery()
</script>

<template>
  <div v-if="images?.length" class="hidden">
    <SectionsImageGalleryPartialsAsGallery v-if="showGallery">
      <button
        v-for="img in images"
        :key="img.id"
        class="gallery-img relative inline-block cursor-pointer"
        :data-src="img.links.hd"
      >
        <img
          :src="replaceImageSize(img.links.hd, 'hd', 's')"
          :alt="getDetailsImageAlt(img, locale)"
        >
      </button>
    </SectionsImageGalleryPartialsAsGallery>
  </div>
</template>
